import React from 'react'
import PropTypes from 'prop-types'
import { graphql, Link } from 'gatsby'
import styled from 'styled-components'
import parse from 'html-react-parser'
import Img from 'gatsby-image'
import { device } from '../components/Breakpoints'
import { Breadcrumb } from '../components/Breadcrumb'
import iconPedidoMedico from '../icons/icon-pedido-medico.svg'
import iconDocumento from '../icons/icon-documento.svg'
import iconCarteirinhaConvenio from '../icons/icon-carteirinha-convenio.svg'
import iconGuiaConvenio from '../icons/icon-guia-convenio.svg'
import iconCarteirinhaPrenatal from '../icons/icon-carteirinha-prenatal.svg'
import iconExames from '../icons/icon-exames-prenatal.svg'
import iconTermos from '../icons/icon-termo.svg'
import imgPlanos from '../img/plano-de-saude.png'
import imgBloco2 from '../img/a-parto-agendado.jpg'
import imgCadastramento from '../img/equipe.png'
import imgProntoAtendimento from '../img/pronto-atendimento.jpg'
import PageHeader from '../components/PageHeader'
import PageEye from '../components/PageEye'
import Layout from '../components/Layout'
import VejaTambem from '../components/VejaTambem'
import { colors } from '../components/Colors'

const div = styled.div`
  max-width: 960px;
  margin: auto;
  @media ${device.mobileL} {
    max-width: 100%;
    text-align: center;
  }
`

const Container = styled.section`
  width: 100%;
  margin-bottom: 2em;
  .inner {
    .content{
      a{
        color: ${colors.verde}!important;
      }
    }
  }
  .intro {
    padding: 1em 2em 3em;
    position: relative;
    margin-top:20px;
    h2{
      font-weight: normal;
    }
    @media ${device.mobileL} {
      padding: 266px 2em 2em!important;
    }
    .image {
      position: absolute;
      display: block;
      right: 1px;
      width: 220px;
      z-index: 3;
      @media ${device.mobileL} {
        right: -3.5em;
        bottom: inherit;
        width: 237px;
        top: -271px;
      }
    }
    @media ${device.mobileL} {
      padding: 1.5em;
    }
    div {
      @media ${device.tablet} {
        width: 50%;
        font-weight: normal;
        font-size: 1em;
        margin-left: 5%;
      }
      @media ${device.mobileL} {
        width: 100%;
        font-weight: normal;
        font-size: 0.8em;
        margin-left: 0;
        box-sizing: border-box;
      }
    }
     p {
        font-size: 1em;
        width: 100%;
        max-width:560px;
        line-height: 1.6em;
        @media ${device.mobileL} {
          width: 100%;
          font-size: 1.5em;
          text-align: left;
        }
      }
      @media ${device.mobileL} {
        margin: 0;
        h2 {
          position: initial;
          text-align: left;
          padding: 0;
        }
      }
    }
  }
}
`

const GroupContent = styled.section`
  padding: 2em 0;

  @media ${device.mobileL} {
    padding: 2em 2em 0;
    p,
    h2 {
      text-align: left;
    }
  }

  .icons {
    flex-wrap: wrap !important;
    div {
      width: 50%;
      @media ${device.mobileL} {
        width: 100%;
        min-width: 100%;
      }
    }
  }
  .inner {
    display: flex;
    justify-content: space-between;
    align-items: flex-end;
    @media ${device.mobileL} {
      flex-wrap: wrap;
    }
    .gatsby-image-wrapper {
      margin: 0;
      :nth-of-type(1) {
        margin-left: 30px;
        @media ${device.mobileL} {
          margin: 30px 0;
        }
      }
      @media ${device.mobileL} {
        margin: 0;
        height: auto;
        width: 100%;
      }
    }
    img {
      margin: 0;
      :nth-of-type(1) {
        margin-left: 30px;
        @media ${device.mobileL} {
          margin: 30px 0;
        }
      }
      @media ${device.mobileL} {
        margin: 0;
        height: auto;
        width: 100%;
      }
    }
    p {
      strong {
        color: ${colors.lilas};
      }
    }
    div {
      width: 50%;
    }
    .nomargin {
      margin-bottom: 0 !important;
      width: auto !important;
      @media ${device.mobileL} {
        width: 100% !important;
      }
    }
    .gridright {
      margin-right: -151px !important;
      margin-top: 0px !important;
    }
    .documentos {
      display: flex;
      box-sizing: border-box;
      justify-content: space-between;
      width: 100%;
      top: 20em;
      background: #ffffff;
      color: #539e9f;
      flex-wrap: wrap;
      margin-bottom: 25px;
      box-shadow: 4px 4px 6px #2c736f;
      padding: 1em 2em 2em;
      font-size: 0.8em;
      @media ${device.mobileL} {
        width: auto;
      }
      ul {
        width: 48%;
        margin: 0;
        padding: 0 2em 0 3em;
        box-sizing: border-box;

        @media ${device.mobileL} {
          width: 100%;
          margin: 0;
          padding: 0;
        }
        :first-child {
          border-right: 1px solid #a7d4c7;
          @media ${device.mobileL} {
            border-right: none;
          }
        }
        li {
          list-style: none;
          box-sizing: border-box;
          padding: 0.5em;
          font-size: 18px;
          position: relative;
          margin-bottom: 0;
          @media ${device.mobileL} {
            width: 100%;
            min-width: 100%;
            text-align: center;
          }
          img {
            width: 40px;
            height: auto;
            position: absolute;
            left: -77px;
            top: 28px;
            @media ${device.mobileL} {
              position: static;
              margin: 1em auto;
              display: block;
            }
          }
          h4 a {
            color: #539e9f;
          }
          p {
            color: ${colors.cinza};
            strong {
              color: #539e9f;
            }
          }
        }
      }
    }
  }

  :nth-of-type(2) {
    background: ${colors.lilasGradiente};
    color: #ffffff;
    @media ${device.mobileL} {
      padding-bottom: 2em;
    }
  }
  :nth-of-type(3),
  :nth-of-type(5) {
    div {
      align-items: center;
    }
    a {
      color: ${colors.cinza};
    }
    h2 {
      color: #8e8fc7;
      margin-top: 0.5em;
    }
  }
  :nth-of-type(4) {
    background: ${colors.laranjaGradienteReverso};
    color: #ffffff;
  }
  :nth-of-type(5) {
    .inner {
      .gatsby-image-wrapper {
        width: 35%;
        img {
          margin: 0;
        }
        @media ${device.mobileL} {
          width: 100%;
        }
      }
      div {
        width: 62%;
        @media ${device.mobileL} {
          width: 100%;
        }
      }
    }
  }
  :nth-of-type(6) {
    background: ${colors.verdeGradiente};
    color: #ffffff;
    margin-bottom: 2em;
    div {
      width: 100%;
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        /**
      Target IE11
      */
        width: 1114px !important;
      }
    }
  }
`
export const InternacaoTemplate = ({
  title,
  content,
  slug,
  image,
  color,
  area = 'Para gestantes',
  sessoes,
}) => {
  const crumbs = [
    { id: 1, link: '/', title: 'Home', icon: true },
    { id: 2, link: '/', title: area, icon: true },
    {
      id: 3,
      link: slug,
      title,
    },
  ]
  return (
    <>
      <Container>
        <Breadcrumb crumbs={crumbs} />
        <PageHeader
          title={title}
          content={content}
          image={image}
          color={color}
          txtColor="lilas"
          height="160px"
          bottom="0px"
          imgWidth="35.6%"
          overflow="visible"
          imgInner
          mobileTop="-19%"
        />
        <GroupContent>
          <div className="inner center">{parse(sessoes[0].texto)}</div>
        </GroupContent>
        <GroupContent>
          <div className="inner center">
            <div>
              <h2>{parse(sessoes[1].tituloDaSessao)}</h2>
              {parse(sessoes[1].texto)}
            </div>
            {sessoes[1].imagemDaSessao.localFile ? (
              <Img
                fluid={
                  sessoes[1].imagemDaSessao.localFile.childImageSharp.fluid
                }
                alt="Parto humanizado"
                className="offsetImgEnd2"
              />
            ) : (
              <img
                src={sessoes[1].imagemDaSessao.sourceUrl}
                alt="Parto humanizado"
                className="offsetImgEnd2"
              />
            )}
          </div>
        </GroupContent>
        <GroupContent>
          <div className="inner center">
            <div>
              <h2>{parse(sessoes[2].tituloDaSessao)}</h2>
              {parse(sessoes[2].texto)}
            </div>
            {sessoes[2].imagemDaSessao.localFile ? (
              <Img
                fluid={
                  sessoes[2].imagemDaSessao.localFile.childImageSharp.fluid
                }
                alt="Admissão pelo pronto atendimento"
                className="offsetImgEnd2"
              />
            ) : (
              <img
                src={sessoes[2].imagemDaSessao.sourceUrl}
                alt="Admissão pelo pronto atendimento"
                className="offsetImgEnd2"
              />
            )}
          </div>
        </GroupContent>
        <GroupContent>
          <div className="inner center">
            <div>
              <h2>{parse(sessoes[3].tituloDaSessao)}</h2>
              {parse(sessoes[3].texto)}
            </div>
            {sessoes[3].imagemDaSessao.localFile ? (
              <Img
                fluid={
                  sessoes[3].imagemDaSessao.localFile.childImageSharp.fluid
                }
                alt="Planos de saúde conveniados"
              />
            ) : (
              <img
                src={sessoes[3].imagemDaSessao.sourceUrl}
                alt="Planos de saúde conveniados"
              />
            )}
          </div>
        </GroupContent>
        <GroupContent>
          <div className="inner center">
            <div>
              <h2>{parse(sessoes[4].tituloDaSessao)}</h2>
              {parse(sessoes[4].texto)}
              <div className="documentos">
                <ul>
                  <li>
                    <h4>
                      <img src={iconPedidoMedico} alt="Pedido médico" />
                      {parse(sessoes[5].tituloDaSessao)}
                    </h4>
                  </li>
                  <li>
                    <h4>
                      <img src={iconDocumento} alt="RG e CPF da paciente" />
                      {parse(sessoes[6].tituloDaSessao)}
                    </h4>
                  </li>
                  <li>
                    <h4>
                      <img src={iconCarteirinhaConvenio} alt="Pedido médico" />
                      {parse(sessoes[7].tituloDaSessao)}
                    </h4>
                  </li>
                  <li>
                    <h4>
                      <img src={iconGuiaConvenio} alt="Pedido médico" />
                      {parse(sessoes[8].tituloDaSessao)}
                    </h4>
                    {parse(sessoes[8].texto)}
                  </li>
                </ul>
                <ul>
                  <li>
                    <h4>
                      <img src={iconCarteirinhaPrenatal} alt="Pedido médico" />
                      {parse(sessoes[9].tituloDaSessao)}
                    </h4>
                  </li>
                  <li>
                    <h4>
                      <img src={iconExames} alt="Pedido médico" />
                      {parse(sessoes[10].tituloDaSessao)}
                    </h4>
                  </li>
                  <li>
                    <h4>
                      <img src={iconTermos} alt="Pedido médico" />
                      {parse(sessoes[11].texto)}
                    </h4>
                    {parse(sessoes[11].texto)}
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </GroupContent>

        <PageEye
          title={sessoes[12].tituloDaSessao}
          content={sessoes[12].texto}
          image={sessoes[12].imagemDaSessao.sourceUrl}
          color="lilas-cinza"
          height="224px"
          bottom="-1px"
          titleWidth="435px"
          imgWidth="32%"
          right="120px"
          overflow="visible"
        />
      </Container>
    </>
  )
}

InternacaoTemplate.propTypes = {
  title: PropTypes.string.isRequired,
  content: PropTypes.string,
}

const Internacao = ({ data, location }) => {
  const { siteMetadata: site } = data.site
  const { wpPage: page } = data
  const image = page.opEsDaPGina.imagem ? page.opEsDaPGina.imagem.sourceUrl : ''
  const area = location.state ? location.state.area : page.opEsDaPGina.area
  const { paginasRelacionadas } = page.opEsDaPGina
  const { sessaoCustomizada: sessoes } = page.SessoesCustomizadas
  const description = page.excerpt
    ? page.excerpt.replace(/<\/?[^>]+(>|$)/g, '').replace(/\n/g, '')
    : ''

  return (
    <Layout title={`${page.title} – ${site.title}`} description={description}>
      <InternacaoTemplate
        title={page.title}
        content={page.content}
        image={image}
        slug={page.slug}
        color={page.opEsDaPGina.corDoCabecalho}
        area={area}
        sessoes={sessoes}
      />
      <VejaTambem relatedPages={paginasRelacionadas} />
    </Layout>
  )
}

Internacao.propTypes = {
  data: PropTypes.object.isRequired,
}

export default Internacao

export const InternacaoQuery = graphql`
  query InternacaoById($id: String!) {
    site {
      siteMetadata {
        url
        title
      }
    }
    wpPage(id: { eq: $id }) {
      title
      content
      slug
      excerpt
      SessoesCustomizadas {
        sessaoCustomizada {
          listaDeItens {
            item
          }
          texto
          tituloDaSessao
          imagemDaSessao {
            sourceUrl
            localFile {
              childImageSharp {
                fluid(quality: 100) {
                  ...GatsbyImageSharpFluid_withWebp
                }
              }
            }
          }
        }
      }
      opEsDaPGina {
        corDoCabecalho
        area
        imagem {
          sourceUrl
        }
        paginasRelacionadas {
          ... on WpPage {
            id
            title
            slug
          }
        }
      }
    }
  }
`
